import css from 'styled-jsx/css';

const styles = css.global`.custom-tabs.tabs-container .tab-item {
    flex: 0 0 145px !important;
}

@media (min-width: 576px) {
    .custom-tabs.tabs-container .tab-item {
        flex: 0 0 145px !important;
    }
}

@media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
}`;

export default styles;